import { Spin } from "antd";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import BillingOnboardingModal from "@/features/BillingOnboardingModal";
import FirstBillingModal from "@/features/FirstBillingModal";

import Sidebar from "./containers/Sidebar";
import { useMainLayoutStore } from "./MainLayout.store";
import { ContainerLayout, ContentLayout } from "./MainLayout.styles";

function MainLayout() {
  const isSidebarCollapsed = useMainLayoutStore(useShallow(state => state.isSidebarCollapsed));

  return (
    <>
      <ContainerLayout hasSider>
        <Sidebar />
        <ContentLayout $isSidebarCollapsed={isSidebarCollapsed}>
          <Suspense fallback={<Spin />}>
            <Outlet />
          </Suspense>
        </ContentLayout>
      </ContainerLayout>
      <FirstBillingModal />
      <BillingOnboardingModal />
    </>
  );
}

export default MainLayout;
